import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react'

const ErrorBoundary = (props) => {
    return (
        <SentryErrorBoundary
            fallback={
                <h1>
                    Couldn't load login view. Something went wrong. Check Sentry
                    for logs
                </h1>
            }
        >
            {props.children}
        </SentryErrorBoundary>
    )
}

export default ErrorBoundary
